BatchGeoStore.addReducer("ToolbarTooltip", function (state, action) {
  state = state || {
    tooltipIsVisible: false,
    tooltipContent: "",
  };

  switch (action.type) {
    case "SHOW_TOOLBAR_TOOLTIP":
      return Object.assign({}, state, {
        tooltipIsVisible: true,
        tooltipContent: action.tooltipContent,
      });

    case "RESET_TOOLBAR_TOOLTIP":
      return Object.assign({}, state, {
        tooltipIsVisible: false,
        tooltipContent: "",
      });

    default:
      return state;
  }
});
